import React, {createContext} from "react";
import useBulkComplianceChecker, {Options} from "../../hooks/compliance/bulk-compliance-checker";

type BulkComplianceCheckerValue = ReturnType<typeof useBulkComplianceChecker>

export const BulkComplianceCheckerContext = createContext<BulkComplianceCheckerValue>(null);

export function BulkComplianceCheckerContextProvider (props: { options?: Options, children: React.ReactNode }) {
    const bulkComplianceChecker = useBulkComplianceChecker(props.options);

    return <BulkComplianceCheckerContext.Provider value={bulkComplianceChecker}>
        {props.children}
    </BulkComplianceCheckerContext.Provider>
}